/* BeautiQ — Interface-Verhalten (Navigation, Einblendungen, Galerie, Warenkorb) */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Höhe der Hinweisleiste an das Layout melden ---- */
  var ann = document.querySelector(".announce");
  var setAnn = function () {
    document.documentElement.style.setProperty("--announce-h", (ann ? ann.offsetHeight : 0) + "px");
  };
  setAnn();
  window.addEventListener("resize", setAnn);
  if (window.ResizeObserver && ann) new ResizeObserver(setAnn).observe(ann);

  /* ---- Header: transparent -> Glas ---- */
  var hdr = document.getElementById("hdr");
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle("solid", window.scrollY > 40); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Mobiles Menü ---- */
  var burger = document.getElementById("burger");
  if (burger) {
    burger.addEventListener("click", function () {
      document.body.classList.toggle("menu");
      burger.setAttribute("aria-expanded", document.body.classList.contains("menu"));
    });
    [].forEach.call(document.querySelectorAll("#mm a"), function (a) {
      a.addEventListener("click", function () { document.body.classList.remove("menu"); });
    });
  }

  /* ---- Hauptnavigation: Klappmenüs ---- */
  (function () {
    var mega = document.querySelector("[data-mega]");
    if (!mega) return;
    var groups = [].slice.call(mega.querySelectorAll(".nl.has-drop"));
    var coarse = window.matchMedia("(hover: none)").matches;

    function closeAll(except) {
      var hd = document.getElementById("hdr");
      if (hd && !except) hd.classList.remove("dropped");
      groups.forEach(function (g) {
        if (g === except) return;
        g.classList.remove("open");
        var t = g.querySelector(".nl-top");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    }
    groups.forEach(function (g) {
      var top = g.querySelector(".nl-top");
      if (!top) return;
      var head = document.getElementById("hdr");
      g.addEventListener("mouseenter", function () {
        if (coarse) return;
        top.setAttribute("aria-expanded", "true");
        if (head) head.classList.add("dropped");
      });
      g.addEventListener("mouseleave", function () {
        if (coarse) return;
        top.setAttribute("aria-expanded", "false");
        if (head) head.classList.remove("dropped");
      });
      top.addEventListener("click", function (e) {
        if (!coarse) return;
        if (!g.classList.contains("open")) {
          e.preventDefault();
          closeAll(g);
          g.classList.add("open");
          top.setAttribute("aria-expanded", "true");
        }
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      closeAll(null);
      var act = document.activeElement;
      if (act && act.closest && act.closest(".nl.has-drop")) act.closest(".nl.has-drop").querySelector(".nl-top").focus();
    });
    document.addEventListener("click", function (e) {
      if (!e.target.closest || !e.target.closest("[data-mega]")) closeAll(null);
    });
  })();

  /* ---- Einblendungen beim Scrollen ---- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -12% 0px" });
    [].forEach.call(document.querySelectorAll(".rv"), function (e) { io.observe(e); });
    [].forEach.call(document.querySelectorAll(".brandmark"), function (e) { io.observe(e); });
  } else {
    [].forEach.call(document.querySelectorAll(".rv,.brandmark"), function (e) { e.classList.add("in"); });
  }

  /* ---- Überschriften mit goldenem Wisch: auf allen Seiten sichtbar machen ----
     (auf der Startseite übernimmt motion.js das Timing; hier der Weg für alle anderen Seiten) */
  var reveals = document.querySelectorAll("[data-reveal]");
  if (reveals.length) {
    var showAll = function () { [].forEach.call(reveals, function (e) { e.classList.add("shown"); }); };
    if ("IntersectionObserver" in window) {
      var ioR = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("shown"); ioR.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px" });
      [].forEach.call(reveals, function (e) { ioR.observe(e); });
    } else { showAll(); }
  }

  /* ---- Hero-Einblendung ---- */
  var hero = document.querySelector(".hero");
  if (hero) requestAnimationFrame(function () { hero.classList.add("on"); });

  /* ---- Logo-Glanz: das Logo maskiert seinen eigenen Lichtreflex ---- */
  [].forEach.call(document.querySelectorAll(".sheen[data-mask]"), function (s) {
    var u = 'url("' + s.getAttribute("data-mask") + '")';
    s.style.webkitMaskImage = u;
    s.style.maskImage = u;
  });

  /* ---- Produktfinder: eine Frage, ein Ergebnis ---- */
  [].forEach.call(document.querySelectorAll("[data-finder]"), function (root) {
    var opts = root.querySelectorAll(".fq-opt");
    var panels = root.querySelectorAll(".fr");
    if (!opts.length) return;
    var pick = function (i) {
      [].forEach.call(opts, function (b, j) {
        b.classList.toggle("on", j === i);
        b.setAttribute("aria-selected", j === i ? "true" : "false");
      });
      [].forEach.call(panels, function (p, j) {
        if (j === i) { p.hidden = false; p.classList.add("on"); }
        else { p.hidden = true; p.classList.remove("on"); }
      });
    };
    [].forEach.call(opts, function (b, i) {
      b.addEventListener("click", function () { pick(i); });
      b.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowDown" && e.key !== "ArrowUp" && e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        e.preventDefault();
        var fwd = e.key === "ArrowDown" || e.key === "ArrowRight";
        var n = (i + (fwd ? 1 : opts.length - 1)) % opts.length;
        opts[n].focus(); pick(n);
      });
    });
    pick(0);
  });

  /* ---- Häufige Fragen: immer nur eine offen ---- */
  [].forEach.call(document.querySelectorAll(".faq-list"), function (list) {
    var items = list.querySelectorAll("details.faq");
    [].forEach.call(items, function (d) {
      d.addEventListener("toggle", function () {
        if (!d.open) return;
        [].forEach.call(items, function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* ---- Anwendungszonen ---- */
  [].forEach.call(document.querySelectorAll("[data-zones]"), function (root) {
    var cards = root.querySelectorAll(".zonecard");
    var figs = root.querySelectorAll(".zonefig");
    var pick = function (i) {
      [].forEach.call(cards, function (c, j) { c.classList.toggle("on", j === i); });
      [].forEach.call(figs, function (f, j) { f.style.opacity = j === i ? "1" : ".35"; });
    };
    [].forEach.call(cards, function (c, i) {
      c.addEventListener("mouseenter", function () { pick(i); });
      c.addEventListener("focus", function () { pick(i); });
      c.addEventListener("click", function () { pick(i); });
    });
  });

  /* ---- Kundenstimmen ---- */
  [].forEach.call(document.querySelectorAll("[data-quotes]"), function (root) {
    var qs = root.querySelectorAll(".q");
    var dots = root.querySelectorAll(".qdots button");
    if (qs.length < 2) return;
    var i = 0, timer = null;
    var show = function (n) {
      i = n;
      [].forEach.call(qs, function (x, j) { x.classList.toggle("act", j === n); });
      [].forEach.call(dots, function (x, j) { x.classList.toggle("on", j === n); });
    };
    [].forEach.call(dots, function (d, j) {
      d.addEventListener("click", function () { show(j); if (timer) clearInterval(timer); });
    });
    if (!reduce) timer = setInterval(function () { show((i + 1) % qs.length); }, 6500);
  });

  /* ---- Produktgalerie ---- */
  [].forEach.call(document.querySelectorAll("[data-gallery]"), function (g) {
    var main = g.querySelector(".gmain img");
    if (!main) return;
    var video = g.querySelector("[data-gallery-video]");
    /* Video zeigen oder wieder zum Bild zurück */
    var showVideo = function (on) {
      if (!video) return;
      video.hidden = !on;
      main.style.visibility = on ? "hidden" : "";
      if (!on && !video.paused) video.pause();
    };
    g.showGalleryVideo = showVideo;
    [].forEach.call(g.querySelectorAll(".gthumbs button"), function (b) {
      b.addEventListener("click", function () {
        if (b.getAttribute("data-video")) {
          showVideo(true);
          if (video && video.play) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
        } else {
          showVideo(false);
          var thumb = b.querySelector("img");
          var full = b.getAttribute("data-full") || (thumb ? thumb.src : "");
          if (full) { main.src = full; main.alt = b.getAttribute("data-alt") || main.alt; }
        }
        [].forEach.call(g.querySelectorAll(".gthumbs button"), function (x) { x.classList.remove("on"); });
        b.classList.add("on");
      });
    });
  });

  /* ---- Galerie folgt der gewählten Ausführung ---- */
  [].forEach.call(document.querySelectorAll("[data-gallery-variant]"), function (g) {
    var form = document.querySelector("[data-variants]");
    if (!form) return;
    var main = g.querySelector(".gmain img");
    var btns = [].slice.call(g.querySelectorAll(".gthumbs button"));

    function colour() {
      var group = form.querySelector("[data-opt]");
      if (!group) return null;
      var checked = group.querySelector("input:checked");
      return checked ? checked.value : null;
    }
    function apply() {
      var c = colour();
      if (c === null) return;
      var first = null;
      btns.forEach(function (b) {
        var f = b.getAttribute("data-for");
        var show = f === "*" || f === c;
        b.hidden = !show;
        b.classList.remove("on");
        if (show && !first && !b.getAttribute("data-video")) first = b;
      });
      if (first) {
        first.classList.add("on");
        if (g.showGalleryVideo) g.showGalleryVideo(false);
        var ft = first.querySelector("img");
        var full = first.getAttribute("data-full") || (ft ? ft.src : "");
        if (main && full) { main.src = full; main.alt = first.getAttribute("data-alt") || main.alt; }
      }
    }
    form.addEventListener("change", apply);
    apply();
  });

  /* ---- Vergleichs-Schieberegler ---- */
  [].forEach.call(document.querySelectorAll("[data-compare]"), function (box) {
    var range = box.querySelector(".cmp-range");
    if (!range) return;
    var apply = function () { box.style.setProperty("--pos", range.value + "%"); };
    range.addEventListener("input", apply);
    range.addEventListener("change", apply);
    apply();
  });

  /* ---- Mengenwahl ---- */
  [].forEach.call(document.querySelectorAll(".qty"), function (q) {
    var input = q.querySelector("input");
    q.addEventListener("click", function (e) {
      var step = e.target.getAttribute("data-step");
      if (!step || !input) return;
      var v = parseInt(input.value, 10) || 1;
      v += parseInt(step, 10);
      input.value = Math.max(1, v);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  /* ---- Variantenwahl: Preis, Verfügbarkeit und Button aktualisieren ---- */
  [].forEach.call(document.querySelectorAll("[data-variants]"), function (form) {
    var data = null;
    try { data = JSON.parse(form.querySelector("[data-variant-json]").textContent); } catch (e) { return; }
    var idField = form.querySelector("[data-variant-id]");
    var btn = form.querySelector("[data-add]");
    var priceNow = form.querySelector("[data-price-now]");
    var priceWas = form.querySelector("[data-price-was]");
    var money = form.getAttribute("data-money") || "{{amount}} €";

    function fmt(cents) {
      var s = (cents / 100).toFixed(2).replace(".", ",");
      var parts = s.split(",");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return money.replace("{{amount}}", parts.join(","));
    }
    function selected() {
      var opts = [];
      [].forEach.call(form.querySelectorAll("[data-opt]"), function (group) {
        var checked = group.querySelector("input:checked");
        opts.push(checked ? checked.value : null);
      });
      for (var i = 0; i < data.length; i++) {
        var v = data[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) ok = false; }
        if (ok) return v;
      }
      return null;
    }
    function update() {
      var v = selected();
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceNow) priceNow.textContent = fmt(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = fmt(v.compare_at_price);
          priceWas.hidden = false;
        } else { priceWas.hidden = true; }
      }
      if (btn) {
        btn.disabled = !v.available;
        var span = btn.querySelector("span");
        if (span) span.textContent = v.available ? btn.getAttribute("data-label") : btn.getAttribute("data-sold");
      }
      if (history.replaceState) {
        history.replaceState({}, "", window.location.pathname + "?variant=" + v.id);
      }
    }
    form.addEventListener("change", update);
    update();
  });
})();

/* Nach dem Absenden eines Formulars (Newsletter, Kontakt) zur Bestätigung scrollen */
(function () {
  if (!/[?&](customer_posted|contact_posted)=true/.test(location.search)) return;
  window.addEventListener("load", function () {
    var msg = document.querySelector(".success");
    if (msg) msg.scrollIntoView({ block: "center" });
  });
})();

/* Hinweisleiste: Schrift so weit verkleinern, dass der Text in eine Zeile passt */
(function () {
  var bar = document.querySelector(".announce");
  if (!bar) return;
  function fit() {
    bar.style.fontSize = "";
    var size = parseFloat(getComputedStyle(bar).fontSize), n = 0;
    while (bar.scrollWidth > bar.clientWidth + 1 && size > 7 && n++ < 40) {
      size -= 0.25; bar.style.fontSize = size + "px";
    }
  }
  fit();
  window.addEventListener("resize", fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();
